export enum ICancelBookingReasons {
  PREVIOUS_SERVICE_ISSUES = 'PREVIOUS_SERVICE_ISSUES',
  BETTER_TRANSPORT_ALTERNATIVE = 'BETTER_TRANSPORT_ALTERNATIVE',
  SCHEDULE_OR_DESTINATION_MISMATCH = 'SCHEDULE_OR_DESTINATION_MISMATCH',
  BOOKING_OR_APP_ISSUES = 'BOOKING_OR_APP_ISSUES'
}
